import { jsx } from "react/jsx-runtime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { validateTidalLicense } from "../../base/index.js";
function CheckCircle(props) {
  return /* @__PURE__ */ jsx(
    CheckCircleIcon,
    {
      "data-testid": "CheckCircle",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CheckCircle",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
CheckCircle.tidalIconMeta = {
  categories: "cancel,informative",
  name: "CheckCircle"
};
validateTidalLicense();
export {
  CheckCircle
};
//# sourceMappingURL=CheckCircle.js.map
